'use client';
import { useEffect, useState } from 'react';
// import { useRouter, useSearchParams } from 'next/navigation'; // Import useRouter
import dynamic from 'next/dynamic';
import Image from 'next/image';
import Link from '@/components/LocaleLink';
// UI Components
import MainForm from './main/mainForm';
import { seo } from '@/utils/seo';
import { useSessionContext } from 'supertokens-auth-react/recipe/session';
import { handleMagicLinkClicked, isThisSameBrowserAndDevice } from '@/magicLinkHandle';
import boys from '../../public/assets/images/boys-nettleworth.webp';
import girls from '../../public/assets/images/girls-nettleworth.webp';
import customImageLoader from './CustomImage';
import useMagicLinkParams from '@/hooks/useMagicLinkParams';
import { useTranslation } from '@/contexts/TranslationContext';
// Dynamically import the icons components
// const BmiIcon = dynamic(() => import('@/components/icons').then((module) => ({ default: module.BmiIcon })), {
//   ssr: false,
// });
// const HeadIcon = dynamic(() => import('@/components/icons').then((module) => ({ default: module.HeadIcon })), {
//   ssr: false,
// });
// const HeightIcon = dynamic(() => import('@/components/icons').then((module) => ({ default: module.HeightIcon })), {
//   ssr: false,
// });
// const WeightIcon = dynamic(() => import('@/components/icons').then((module) => ({ default: module.WeightIcon })), {
//   ssr: false,
// });
// TODO // CODE TO REMOVE ABOVE
const MainComponent = () => {
  const session = useSessionContext();
  const { t } = useTranslation();
  const rid = useMagicLinkParams(); //using custom hook for detacting passwordless auth to avoid CLS issue using suspense.

  const [renderAdSlot, setRenderAdSlot] = useState(false);

  useEffect(() => {
    // setRenderAdSlot(window.innerWidth > 1000);
    // TODO // ads remove
  }, []);

  useEffect(() => {
    localStorage.removeItem('lm_heigh_data');
    localStorage.removeItem('lm_weight_data');
    localStorage.removeItem('lm_head_data');
    localStorage.removeItem('lm_bmi_data');

    const consumeMagicLinkIfPresent = async () => {
      // const { query } = router;
      // const isMagicLinkPresent = query.rid === 'thirdpartypasswordless';

      const isMagicLinkPresent = rid === 'thirdpartypasswordless';

      if (isMagicLinkPresent) {
        const sameBrowserAndDevice = await isThisSameBrowserAndDevice();
        if (sameBrowserAndDevice) {
          await handleMagicLinkClicked();
        }
      }
    };

    if (!session.doesSessionExist) {
      consumeMagicLinkIfPresent();
    }
  }, [rid, session]);

  useEffect(() => {
    seo(window.location.pathname);
    const handleScroll = () => {
      const homeStartIcon = document.querySelector('.home-start-icon');
      const greenHomeStartIcon = document.querySelector('.green-home-start-icon');

      if (homeStartIcon && greenHomeStartIcon) {
        homeStartIcon.style.top = `${window.scrollY - 738}px`;
        greenHomeStartIcon.style.top = `${window.scrollY - 150 - 738}px`;

        if (window.scrollY >= 990) {
          greenHomeStartIcon.classList.add('stop');
        } else {
          greenHomeStartIcon.classList.remove('stop');
        }

        if (window.scrollY <= 738) {
          homeStartIcon.classList.add('stop-top');
        } else {
          homeStartIcon.classList.remove('stop-top');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
       <style dangerouslySetInnerHTML={{
        __html: `
          .home-vm-vid .vm-vid {
            @media (max-width: 500px) {
              margin-top: -203px !important;
            }
          }
        `
      }} />
      <section className="main-first">
        <div className="row pt-5 pb-5 home-vm-vid"></div>
        <div className="row">
          <div className="hero d-flex justify-content-center align-items-center flex-column">
            <div className="content-container position-relative">
              <h1 className="banner-heading mb-5">
                {t('home.heroTitle1')}
                <br className="d-none d-md-block" />
                {t('home.heroTitle2')}
              </h1>
              <span>{t('home.startJourney')}</span>
              <div className="dropdownicon text-white position-relative mb-5">
                <div className="down-arrows">
                  <span></span>
                </div>
              </div>
              <div className="cartoon-information">
                <MainForm />
              </div>
              <Image priority className="lines" src="/assets/images/NW-lines.svg" alt="lines" height="20" width="200" />

              <div className="home-icons">
                <div className="home-icons-top">
                  <div className="home-start-icon animateIconBackground">
                    <Image
                      priority
                      src="/assets/images/icons/NW-animateIcon.svg"
                      alt="NW"
                      className="full"
                      height="26"
                      width="36"
                    />
                  </div>
                </div>
                <div className="home-icons-bottom">
                  <div className="green-home-start-icon animateIconBackground">
                    <Image
                      priority
                      src="/assets/images/icons/NW-animateIcon.svg"
                      alt="NW"
                      className="full"
                      height="26"
                      width="36"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="getting-started-section">
        <div className="row py-3">
          <h2>{t('home.itsJustSimple')}</h2>
        </div>
        <div className="row middle-row max-width layout-align-center-center">
          <div className="col-6 col-lg-3">
            <span className="icon-home">
              <Image src="/assets/images/icons/clock.svg" alt="results" width="130" height="139" />
            </span>
            <h3>{t('home.instantResults')}</h3>
          </div>
          <div className="col-6 col-lg-3">
            <span className="icon-home">
              <Image src="/assets/images/icons/compare.svg" alt="compare" width="130" height="139" />
            </span>
            <h3>{t('home.compare')}</h3>
          </div>
          <div className="col-6 col-lg-3">
            <span className="icon-home">
              <Image src="/assets/images/icons/track.svg" alt="track" width="130" height="139" />
            </span>
            <h3>{t('home.trackProgress')}</h3>
          </div>
          <div className="col-6 col-lg-3">
            <span className="icon-home">
              <Image src={'/assets/images/icons/message-green.svg'} alt="share" width="130" height="139" />
            </span>
            <h3>{t('home.shareStories')}</h3>
          </div>
        </div>
      </section>

      <section id="chart-section" className="chart-section p-xs-2 p-lg-4">
        <div className="row py-3 mt-5 mt-lg-0">
          <h2>{t('home.comparisonCharts')}</h2>
        </div>
        <div className="row max-width layout-align-center-center">
          <div className="col-12">
            <div className="card px-3 px-md-3 px-lg-5 boys">
              <Image loader={customImageLoader} placeholder="blur" className="card-img" alt="men" src={boys} />
              <div className="card-body">
                <h3>{t('home.men')}</h3>
                <div className="card-links-wrapper">
                  <Link className="card-links py-2 px-3 px-md-3" prefetch={false} href="/net-worth/men">
                    {/* <HeightIcon color={'#25AF9B'} /> */}
                    {t('nav.netWorth')}
                  </Link>
                  <Link className="card-links py-2 px-3 px-md-3" prefetch={false} href="/annual-income/men">
                    {/* <WeightIcon color={'#25AF9B'} /> */}
                    {t('nav.income')}
                  </Link>
                  <Link className="card-links py-2 px-3 px-md-3" prefetch={false} href="/retirement-fund/men">
                    {/* <BmiIcon color={'#25AF9B'} /> */}
                    {t('nav.retirement')}
                  </Link>
                  {/* <Link className="card-links py-2 px-3 px-md-3" prefetch={false} href="/head-charts/boys">
                    <HeadIcon color={'#25AF9B'} />
                    Head
                  </Link> */}
                </div>
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="card px-3 px-md-3 px-lg-5 girls">
              <Image
                loader={customImageLoader}
                placeholder="blur"
                className="card-img object-lg-contain"
                alt="girls"
                src={girls}
              />
              <div className="card-body">
                <h3>{t('home.women')}</h3>
                <div className="card-links-wrapper">
                  <Link className="card-links py-2 px-3 px-md-3" prefetch={false} href="/net-worth/women">
                    {/* <HeightIcon color={'#25AF9B'} /> */}
                    {t('nav.netWorth')}
                  </Link>
                  <Link className="card-links py-2 px-3 px-md-3" prefetch={false} href="/annual-income/women">
                    {/* <WeightIcon color={'#25AF9B'} /> */}
                    {t('nav.income')}
                  </Link>
                  <Link className="card-links py-2 px-3 px-md-3" prefetch={false} href="/retirement-fund/women">
                    {/* <BmiIcon coxlor={'#25AF9B'} /> */}
                    {t('nav.retirement')}
                  </Link>
                  {/* <Link className="card-links py-2 px-3 px-md-3" prefetch={false} href="/head-charts/girls">
                    <HeadIcon color="#25AF9B" />
                    Head
                  </Link> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <script
          type="application/ld+json"
          id="schema-script"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'WebPage',
              name: 'NettleWorth',
              description:
                'Compare your financial position to others in your demographic using interactive charts and calculators. Discover insights and track your net worth.',
              url: `${process.env.NEXT_PUBLIC_BASE_URL}`,
              publisher: {
                '@type': 'Organization',
                name: 'NettleWorth',
                logo: {
                  '@type': 'ImageObject',
                  url: `${process.env.NEXT_PUBLIC_BASE_URL}/assets/images/logos/LM-logo.svg`,
                },
                sameAs: ['https://www.facebook.com/nettleworth', 'https://twitter.com/nettleworth'],
              },
              mainEntityOfPage: {
                '@type': 'WebPage',
                '@id': `${process.env.NEXT_PUBLIC_BASE_URL}`,
              },
            }),
          }}
        />
      </section>
    </>
  );
};

const Main = () => <MainComponent />;

export default Main;
